import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faFacebook,
  faGithub,
  faHackerrank,
  faKaggle,
  faLinkedin,
  faFreeCodeCamp,
} from "@fortawesome/free-brands-svg-icons";

import {
  faMoon,
  faSun,
  faEnvelope,
  faFileCode,
} from "@fortawesome/free-regular-svg-icons";

library.add(
  faFacebook,
  faGithub,
  faLinkedin,
  faHackerrank,
  faKaggle,
  faMoon,
  faSun,
  faEnvelope,
  faFreeCodeCamp,
  faFileCode
);

export {};
